const ImageLogoIcon = (props: {url: string}) => {
  return <img src={props.url} alt="logo" style={{ height: 28, width: 'auto' }} />;
}

export default ImageLogoIcon;
